import { WorkType } from '@Components/ViewWork/work-type'
import Navigation from '@App/navigation'

const generateEditLink = (
    workStep: 'recordings' | 'workDetails' | 'publishers',
    viewWorkId: number,
    rightsholderId?: number,
    workType?: WorkType
) => {
    if (!workType || !rightsholderId) {
        return Navigation.home.root()
    }
    switch (workType) {
        case 'bulk':
            return Navigation.rightholder.createWork.bulk.edit[workStep](rightsholderId)
        case 'create-form':
            return Navigation.rightholder.createWork.form[workStep](rightsholderId)
        case 'create-wizard':
            return Navigation.rightholder.createWork.wizard[workStep](rightsholderId)
        case 'draft':
            return Navigation.rightholder.registrationDrafts[workStep](rightsholderId, workType, viewWorkId)
        default:
            return Navigation.rightholder.catalog.workEdit[workStep](rightsholderId, workType, viewWorkId)
    }
}

export default generateEditLink
